<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0"><i class="fas fa-edit mr-2" /> แก้ไขข้อมูล</h2>
			</template>
			<template>
				<form @submit.prevent="saveMember">
					<div class="row">
						<div class="col-md-6">
							<base-input label="เบอร์โทรศัพท์" v-model="info.phone" required />
						</div>
						<div class="col-md-6">
							<base-input label="Truewallet ID" placeholder="Truewallet ID" v-model="info.twID" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<base-input label="ชื่อ" v-model="info.firstName" required />
						</div>
						<div class="col-md-6">
							<base-input label="นามสกุล" v-model="info.lastName" required />
						</div>
						<div class="col-md-12 mb-3">
							<base-button
								native-type="button"
								type="default"
								class="btn-sm"
								:disabled="fetchingBankAccount"
								@click="fetchNameFromBankAccount"
							>
								ดึงข้อมูลจากบัญชีธนาคาร
							</base-button>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<base-input
								label="ชื่อ (ภาษาอังกฤษ)"
								placeholder="ชื่อ (ภาษาอังกฤษ)"
								v-model="info.firstNameEN"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								label="นามสกุล (ภาษาอังกฤษ)"
								placeholder="นามสกุล (ภาษาอังกฤษ)"
								v-model="info.lastNameEN"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<base-input label="ธนาคาร" required>
								<el-select v-model="info.bankCode" placeholder="ธนาคาร">
									<el-option v-for="(v, index) in banks" :key="index" :label="v" :value="index" />
								</el-select>
							</base-input>
						</div>
						<div class="col-md-6">
							<base-input label="เลขบัญชี" placeholder="เลขบัญชี" v-model="info.bankNumber" required />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<base-input type="password" label="รหัสผ่าน" placeholder="รหัสผ่าน" v-model="info.password" />
						</div>
						<div class="col-md-6">
							<base-input
								type="password"
								label="รหัสผ่าน (สำหรับเปิดยูซเซอร์ใหม่)"
								placeholder="รหัสผ่าน (สำหรับเปิดยูซเซอร์ใหม่)"
								v-model="info.gamePassword"
							/>
						</div>
					</div>
					<hr class="my-3" />
					<div class="row">
						<div class="col-md-6" v-if="info.affiliate">
							<base-input
								type="number"
								label="ยอดเชิญเพื่อน"
								placeholder="0"
								v-model.number="info.affiliate.balance"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								type="number"
								label="เทิร์นที่ต้องทำ"
								placeholder="0"
								v-model.number="info.totalTurn"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								type="number"
								label="ยอดถอนขั้นต่ำ"
								placeholder="0"
								v-model.number="info.minWithdraw"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								type="number"
								label="ยอดถอนสูงสุด"
								placeholder="0"
								v-model.number="info.maxWithdraw"
							/>
						</div>
					</div>
					<div class="mt-2">
						<base-button native-type="submit" type="default" icon :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import MemberService from '../../services/member.service'
import banks from '../../banks.json'

export default {
	props: ['open', 'memberInfo'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			banks: banks,
			info: {},

			fetchingBankAccount: false,
		}
	},
	computed: {
		fullName() {
			return `${this.firstName} ${this.lastName}`
		},
	},
	methods: {
		close() {
			this.$emit('close')
		},
		saveMember() {
			this.loading = true

			const info = Object.assign({}, this.info)
			info.totalTurn = parseFloat(info.totalTurn)
			info.minWithdraw = parseFloat(info.minWithdraw)
			info.maxWithdraw = parseFloat(info.maxWithdraw)
			MemberService.saveMember(info.id, info)
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('close')
					this.$emit('reloadMember')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
		async fetchNameFromBankAccount() {
			this.fetchingBankAccount = true

			try {
				const res = await MemberService.fetchNameFromBankAccount(this.memberInfo.id)

				this.info.firstName = res.firstName
				this.info.lastName = res.lastName
				this.$notify({
					type: 'success',
					message: 'ดำเนินการสำเร็จ กรุณาบันทึกข้อมูลเพื่อแก้ไข',
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.fetchingBankAccount = false
			}
		},
	},
	watch: {
		memberInfo(v) {
			this.info = Object.assign({}, v, {
				password: '',
			})
		},
	},
}
</script>
